import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getDashboardManagers, getDashboardScope } from '../api/dashboardApi'

/**
 * Kişi seçicisinin seçenekleri = kapsam kişileri (068). Organizasyon verisinden gelir, nadiren değişir
 * → uzun `staleTime`. Boş dönerse (kapsam çözülemedi / HR erişilemedi / kullanıcının astı yok) çağıran
 * seçiciyi **hiç göstermez** ama panonun geri kalanı çalışmaya devam eder (analiz §1.12.1).
 *
 * <p><b>`i18n.language` queryKey'in parçasıdır:</b> `jobTitle` (unvan) HR kaynağından `Accept-Language`'e
 * göre çözülür → dil değişince seçenek etiketleri yenilenmelidir. Uzun `staleTime` tek başına yetmez:
 * anahtar değişmezse eski dildeki yanıt önbellekten sunulur.
 */
export function useDashboardManagers() {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['dashboard-managers', i18n.language],
    queryFn: getDashboardManagers,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}

/**
 * Kapsam bilgisi — kişi filtresinin **başlığı** ("Tüm Yöneticiler" ↔ "Tüm Bağlı Kullanıcılar") ve
 * görünürlüğü buradan gelir. Kural sunucuda çözülür (spec §K3); istemci yetki mantığını tekrarlamaz.
 *
 * <p>Dilden bağımsızdır (yalnız kod + boole döner) → `i18n.language` anahtarda yer almaz.
 */
export function useDashboardScope() {
  return useQuery({
    queryKey: ['dashboard-scope'],
    queryFn: getDashboardScope,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
